import * as m from 'mithril';
import { PaymentDetailsForm } from './SelectedPaymentOption';
import AppContext from '../../context/AppContext';
import Either from '../../types/Either';
import CustomSvgIcon from '../../components/CustomSvgIcon';
import { ErrorDTO, PaymentOptionDTO, PromoCodeVerifiedResponseDTO } from '../../apiclient/ApiDtos';


export const SpinnerOverlay = {
    view: function () {
        return m("div.spinner-overlay.d-flex.justify-content-center.align-items-center", [
            m("div.spinner-border.text-primary[role='status']", [
            ])
        ]);
    }
};


export function SelectedPaymentModal(): m.Component<{
    appContext: AppContext,
    isOpen: boolean,
    selectedPaymentOption: PaymentOptionDTO,
    promoAppliedResult: Either<ErrorDTO, PromoCodeVerifiedResponseDTO> | null,
    showPromoCodeInvalidError?: boolean,
    showLoading: boolean,
    onApplyPromoCode: (promoCode: string) => void,
    onRemovePromoCode: () => void,
    onSubmitPayment: () => void,
    onClose: () => void
}> {


    let showError = false;
    var isKeyboardOpen = false;


    function handelModalPositionWithKeyboard() {
        var activeElement = document.activeElement;
        if (activeElement && (activeElement.nodeName === 'INPUT' || activeElement.nodeName === 'TEXTAREA')) {
            var rect = activeElement.getBoundingClientRect();
            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                isKeyboardOpen = false;
            } else {
                activeElement.scrollIntoView();
                isKeyboardOpen = true;
            }
            var dialog = document.getElementById("dialog");
            if (dialog) {
                if (isKeyboardOpen) {
                    dialog.classList.add("dialog-focused");
                } else {
                    dialog.classList.remove("dialog-focused");
                }
            }
        }
    }

    return {
        view: function (vnode) {
            let messageProvider = vnode.attrs.appContext.getMessageProvider();
            handelModalPositionWithKeyboard();

            return m("div.payment-dialog-area", {
                class: vnode.attrs.isOpen ? "modal-backdrop" : "",
                onclick: (event) => {
                    event.preventDefault();
                    vnode.attrs.onClose();
                }
            },
                m("dialog.border-0 p-0 bg-white", {
                    id: "dialog",
                    open: vnode.attrs.isOpen,
                    onclick: (event) => {
                        event.stopPropagation();
                    }
                },

                    m("div.mb-2 position-relative", {
                        class: "card border-0"
                    }, [

                        vnode.attrs.showLoading ? m(SpinnerOverlay) : null,
                        m("div.card-header bg-white border-0",
                            m("div.d-flex justify-content-between",
                                m("div.font-weight-bold fw-bold mb-1", messageProvider.get("title_payment_method")),
                                m("div.pl-3", {
                                    onclick: () => {
                                        vnode.attrs.onClose()
                                    }
                                },
                                    m(CustomSvgIcon, {
                                        iconType: 'close',
                                        themeCssClass: "svg-muted svg-medium"
                                    })
                                )
                            ),
                        ),
                        m("div.card-body border-top",
                            m("div.row", [
                                m("div.col-6", [
                                    m("img.img-logo", {
                                        class: "align-middle",
                                        src: vnode.attrs.selectedPaymentOption.paymentMethod.logoUrl,
                                    })
                                ]),
                                m("div.col-6", [
                                    m("div.text-right text-end", vnode.attrs.selectedPaymentOption.paymentMethod.title),
                                    m("div.text-muted text-right text-end", m("small", {}, "MMK"))
                                ])
                            ])
                        ),

                        m("div.card-body", { class: "border-top" },
                            m(PaymentDetailsForm, {
                                hidePromoArea: false,
                                paymentOption: vnode.attrs.selectedPaymentOption,
                                appliedPromo: vnode.attrs.promoAppliedResult?.right ? vnode.attrs.promoAppliedResult?.right : null,
                                showPromoCodeInvalidError: vnode.attrs.promoAppliedResult?.left ? true : false,
                                messageProvider: messageProvider,
                                onAddPromoCode: (promoCode: string) => {
                                    vnode.attrs.onApplyPromoCode(promoCode)
                                },
                                onRemovePromoCode: () => {
                                    vnode.attrs.onRemovePromoCode()
                                },
                                onSubmitPayment: () => {
                                    vnode.attrs.onSubmitPayment()
                                },
                            }),
                        )
                    ])
                ));
        }
    };
}
